import AlertDashboard from 'pages/Autops/AlertDashboard';
import Home from 'pages/Home/Home';
import ManageBidirectionalTemplate from 'pages/ManageBidirectionalTemplate/ManageBidirectionalTemplate';
import ManageTemplate from 'pages/ManageTemplate/ManageTemplate';
import UploadBulkRequest from 'pages/UploadBulkRequest/UploadBulkRequest';

const protectedRoutes = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/home',
    element: <Home />,
  },
  {
    path: '/upload-bulk',
    element: <UploadBulkRequest />,
  },
  {
    path: '/manage-template',
    element: <ManageTemplate />,
  },
  {
    path: '/manage-bidirectional-template',
    element: <ManageBidirectionalTemplate />,
  },
  { path: '/autops', element: <AlertDashboard /> },
];

export default protectedRoutes;
